import { render, staticRenderFns } from "./livingScreen.vue?vue&type=template&id=9ae55f18&scoped=true&"
import script from "./livingScreen.vue?vue&type=script&lang=js&"
export * from "./livingScreen.vue?vue&type=script&lang=js&"
import style0 from "./livingScreen.vue?vue&type=style&index=0&id=9ae55f18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae55f18",
  null
  
)

export default component.exports